import React from 'react'
import { Button } from 'components/common'
import styles from './TableHeader.module.scss'
import tableSizes from '../viewers-table-sizes.module.scss'
import { IconUserCircle, IconEnvelope, IconUsers, IconCalendarDate, IconLocation, IconChart } from 'assets'
import { observer } from 'mobx-react-lite'
import { inject } from 'mobx-react'
import { VIEWERS_STORE } from 'store'
import { Props } from './types'
import { isDescending, SortDirection, getDirectionSymbol } from 'utilities'

const TableHeaderComponent = (props: Props) => {
  const {
    [VIEWERS_STORE]: { selectedSortTab },
    sortDirection,
    setSortDirection
  } = props

  const toggleSortDirection = () => {
    setSortDirection(
      isDescending(sortDirection)
        ? SortDirection.ASC
        : SortDirection.DESC
    )
  }

  return (
    <div className={styles.container}>
      <Button
        className={styles.tableHeaderBttn}
        style={{ width: tableSizes.fullNameWidth, paddingLeft: 0 }}
      >
        <IconUserCircle />
        Full name
      </Button>
      <Button
        className={styles.tableHeaderBttn}
        style={{ width: tableSizes.dynamicColWidth, justifyContent: 'center' }}
        onClick={toggleSortDirection}
      >
        <IconChart />
        {selectedSortTab}
        <span>
          {getDirectionSymbol(sortDirection)}
        </span>
      </Button>
      <Button
        className={styles.tableHeaderBttn}
        style={{ width: tableSizes.emailWidth }}
      >
        <IconEnvelope />
        E-mail
      </Button>
      <Button
        className={styles.tableHeaderBttn}
        style={{ width: tableSizes.genderWidth, justifyContent: 'center' }}
      >
        <IconUsers />
        Gender
      </Button>
      <Button
        className={styles.tableHeaderBttn}
        style={{ width: tableSizes.ageWidth }}
      >
        <IconCalendarDate />
        DOB, Age
      </Button>
      <Button
        className={styles.tableHeaderBttn}
        style={{ width: tableSizes.addressWidth }}
      >
        <IconLocation />
        Address
      </Button>
    </div>
  )
}

const TableHeader = inject(VIEWERS_STORE)(observer(TableHeaderComponent))
export { TableHeader }
